import React, { memo } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import PropTypes from "prop-types";
import CustomOffCanvasLast from '../CustomOffCanvasLast.jsx';
import "./features.common.styles.scss";

const EmptyDrillDownLast = ({ subHeading }) => {
  const commonSliceState = useSelector((state) => state.common);
  const offcanvasLastState = commonSliceState?.offcanvasLastState;
  const selectedData = get(offcanvasLastState, "selectedData", []);

  return (
    <CustomOffCanvasLast className="custom-off-canvas drilldownLast padding25">
      <div className="meantimewrap custom_scroll">
        <h3 className="flowhead">
          {offcanvasLastState?.title}
          {subHeading && <span>{subHeading}</span>}
        </h3>
        {selectedData ? selectedData : null}
      </div>
    </CustomOffCanvasLast>
  );
};

EmptyDrillDownLast.propTypes = {
  subHeading: PropTypes.string,
};

export default memo(EmptyDrillDownLast);


